(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisado-product-story-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lisado-story-product')) {
  customElements.define('lisado-story-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form.se-story__form');
      if (!this.form) return;
      this.variant = this.form.querySelector('[data-story-variant]');
      this.offers = [...this.form.querySelectorAll('[data-story-quantity]')];
      this.plan = this.form.querySelector('[data-story-plan]');
      this.plans = JSON.parse(this.querySelector('[data-story-plans]')?.textContent || '{}');
      this.button = this.form.querySelector('.se-story__add');
      this.error = this.querySelector('.se-story__error');
      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-story-variant],[data-story-quantity],[data-story-plan]')) this.update(true);
      }, options);
      this.form.addEventListener('submit', event => this.add(event), options);
      this.slides = this.querySelector('.se-story__slides');
      if (this.slides) {
        const slides = [...this.slides.children];
        const thumbs = [...this.querySelectorAll('[data-slide]')];
        const position = index => Math.max(0, Math.min(this.slides.scrollWidth - this.slides.clientWidth, slides[index].offsetLeft - slides[0].offsetLeft));
        this.goToSlide = index => {
          const target = Math.max(0, Math.min(index, slides.length - 1));
          this.slides.scrollTo({left:position(target), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.updateGallery = () => {
          const previousSlide = this.activeSlide;
          this.activeSlide = slides.reduce((best, slide, index) => Math.abs(position(index) - this.slides.scrollLeft) < Math.abs(position(best) - this.slides.scrollLeft) ? index : best, 0);
          if (Number.isInteger(previousSlide) && previousSlide !== this.activeSlide) window.pauseAllMedia?.();
          thumbs.forEach(button => {const active = Number(button.dataset.slide) === this.activeSlide;button.classList.toggle('is-aktiv', active);button.setAttribute('aria-current', String(active));});
          this.querySelector('.mmb__fahne')?.classList.toggle('ist-weg', this.activeSlide !== 0);
        };
        thumbs.forEach(button => button.addEventListener('click', () => this.goToSlide(Number(button.dataset.slide)), options));
        this.slides.addEventListener('scroll', () => {cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.updateGallery);}, {...options, passive:true});
        this.slides.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          this.goToSlide(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : (this.activeSlide || 0) + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        window.addEventListener('resize', this.updateGallery, options);
        if (window.ResizeObserver) {this.resizeObserver = new ResizeObserver(this.updateGallery);this.resizeObserver.observe(this.slides);}
        this.updateGallery();
      }
      document.addEventListener('lisado-story:selection', event => {
        if (event.detail.source === this || event.detail.product !== this.dataset.product) return;
        this.variant.value = event.detail.variant;
        if (this.plan) this.plan.value = event.detail.plan || '';
        const offer = this.offers.find(input => Number(input.value) === event.detail.quantity);
        if (offer) offer.checked = true;
        this.update(false);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.se-story__slide');
        if (slide && this.contains(slide)) this.goToSlide?.([...this.slides.children].indexOf(slide));
      }, options);
      if (this.dataset.mode === 'final') {
        const main = document.querySelector('lisado-story-product[data-mode="main"]');
        const mainVariant = main?.querySelector('[data-story-variant]');
        const mainQuantity = main?.querySelector('[data-story-quantity]:checked');
        if (this.plan && main?.plan) this.plan.value = main.plan.value;
        if (mainVariant && [...this.variant.options].some(option => option.value === mainVariant.value)) this.variant.value = mainVariant.value;
        const offer = this.offers.find(input => input.value === mainQuantity?.value);
        if (offer) offer.checked = true;
      }
      this.update(false);
      const selected = this.offers.find(input => input.checked && !input.disabled);
      if (selected) document.dispatchEvent(new CustomEvent('lisado-story:selection', {detail:{source:this,product:this.dataset.product,variant:this.variant.value,plan:this.plan?.value || '',quantity:Number(selected.value),price:this.money(this.price(selected,this.variant.selectedOptions[0].dataset).total)}}));
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); cancelAnimationFrame(this.frame); }
    money(cents) { return new Intl.NumberFormat(this.dataset.locale || 'de', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(cents / 100); }
    unitPrice(total, quantity, variant) {
      const factor = {kg:1, g:0.001, mg:0.000001}[variant.measureUnit];
      const netKg = Number(variant.measureValue) * factor;
      if (netKg > 0 && quantity > 0) return {unit:Math.round(total / (netKg * quantity)), reference:'kg'};
      const baseTotal = Number(variant.price) * quantity;
      const reference = (variant.reference || '').replace(/^1(?=[a-z])/i, '');
      return {unit:baseTotal > 0 ? Math.round(Number(variant.unit) * total / baseTotal) : 0, reference};
    }
    bundleRule(price, quantity) {
      if (this.dataset.bundleRules !== 'true' || quantity <= 1) return {discount:0, badge:''};
      const reachesFreeShipping = Number(price) * quantity >= (Number(this.dataset.freeShippingThreshold) || 5100);
      if (quantity === 2) return reachesFreeShipping
        ? {discount:0, badge:'Gratis Versand'}
        : {discount:10, badge:'10 % Rabatt'};
      return reachesFreeShipping
        ? {discount:10, badge:'10 % Rabatt + Gratis Versand'}
        : {discount:15, badge:'15 % Rabatt'};
    }
    price(input, variant) {
      const allocation = this.plans[this.variant.value]?.[this.plan?.value];
      const price = Number(allocation ? allocation.price : variant.price);
      const quantity = Number(input.value);
      const baseTotal = price * quantity;
      const rule = this.bundleRule(price, quantity);
      const discountPercent = this.dataset.bundleRules === 'true' ? rule.discount : Number(input.dataset.discount);
      input.dataset.discount = String(discountPercent);
      const discount = allocation ? 0 : Math.round(baseTotal * Math.min(100, Math.max(0, discountPercent)) / 100);
      const total = baseTotal - discount;
      return {each:Math.round(total / quantity), total, compare:Math.max(price,Number(allocation ? allocation.compare : variant.compare)) * quantity, ...this.unitPrice(total, quantity, variant)};
    }
    update(broadcast) {
      const option = this.variant.selectedOptions[0];
      if (!option) return;
      const variant = option.dataset;
      const allocations = this.plans[this.variant.value] || {};
      if (this.plan) {
        for (const plan of this.plan.options) {
          plan.disabled = plan.value ? !allocations[plan.value] : variant.planRequired === 'true';
          plan.hidden = plan.disabled;
        }
        if (!this.plan.selectedOptions[0] || this.plan.selectedOptions[0].disabled) this.plan.value = [...this.plan.options].find(p => !p.disabled)?.value || '';
      }
      const allocation = allocations[this.plan?.value];
      this.querySelectorAll('[data-plan-note],[data-plan-total]').forEach(el => el.hidden = !allocation);
      const onceNote = this.querySelector('[data-once-note]');
      if (onceNote) onceNote.hidden = !!allocation;
      const description = this.querySelector('[data-plan-description]');
      if (description) {description.textContent = allocation?.description || '';description.hidden = !description.textContent;}
      this.offers.forEach(input => {
        const quantity = Number(input.value);
        input.disabled = variant.available !== 'true' || (variant.planRequired === 'true' && !allocation) || quantity < Number(variant.min) || (Number(variant.max) > 0 && quantity > Number(variant.max)) || (quantity - Number(variant.min)) % Number(variant.step) !== 0;
        const row = input.closest('.se-story__offer');
        row.classList.toggle('is-disabled', input.disabled);
        row.classList.toggle('sr-bundle__bar--selected',input.checked);
        const bundleRule = this.bundleRule(Number(variant.price), quantity);
        const badge = row.querySelector('[data-bundle-badge]');
        if (badge && this.dataset.bundleRules === 'true') {
          badge.textContent = bundleRule.badge;
          badge.hidden = !bundleRule.badge;
        }
        const prices = this.price(input, variant);
        row.querySelector('[data-total]').textContent = this.money(prices.total);
        row.querySelector('[data-each]').textContent = this.money(prices.each);
        const compare = row.querySelector('[data-compare]');
        compare.textContent = this.money(prices.compare);
        compare.hidden = prices.compare <= prices.total;
      });
      let selected = this.offers.find(input => input.checked && !input.disabled);
      if (!selected) { selected = this.offers.find(input => !input.disabled); if (selected) selected.checked = true; }
      this.offers.forEach(input=>input.closest('.se-story__offer').classList.toggle('sr-bundle__bar--selected',input.checked));
      this.button.disabled = !selected || this.busy;
      this.button.querySelector('[data-button-label]').textContent = selected ? this.dataset.addLabel : this.dataset.soldLabel;
      const delivery = this.querySelector('[data-plan-delivery]');
      if (delivery) delivery.textContent = allocation && selected ? this.money(allocation.delivery * Number(selected.value)) : '';
      const price = selected ? this.price(selected,variant) : {total:Number(variant.price),...this.unitPrice(Number(variant.price),1,variant)};
      this.querySelectorAll('[data-selected-total], [data-story-button-price]').forEach(el => el.textContent = this.money(price.total));
      const unit = this.querySelector('[data-selected-unit]');
      unit.textContent = price.reference ? this.money(price.unit) + '/' + price.reference : '';
      const availability = this.querySelector('[data-availability]');
      if (availability) availability.textContent = variant.available === 'true' ? this.dataset.stockLabel : this.dataset.soldLabel;
      this.form.querySelector('[data-story-variant-input]').value = this.variant.value;
      this.form.querySelector('[data-story-quantity-input]').value = selected?.value || '0';
      const planInput = this.form.querySelector('[data-story-plan-input]');
      planInput.value = this.plan?.value || '';
      planInput.disabled = !planInput.value;
      if (broadcast && selected) {
        const detail = {source:this,product:this.dataset.product,variant:this.variant.value,plan:this.plan?.value || '',quantity:Number(selected.value),price:this.money(price.total)};
        document.dispatchEvent(new CustomEvent('lisado-story:selection',{detail}));
        const url = new URL(location.href); url.searchParams.set('variant',this.variant.value); history.replaceState({},'',url);
      }
    }
    ajaxUrl(route) {
      const url = new URL(route, location.origin);
      url.pathname = url.pathname.replace(/\/$/, '').replace(/(?:\.js)?$/, '.js');
      return url.pathname + url.search;
    }
    cartError(response, result) {
      const status = Number(result?.status);
      if (response.ok !== false && !(response.status >= 400) && !(status >= 400)) return null;
      const message = [result?.description, result?.message, result?.errors].find(value => typeof value === 'string' && value.trim());
      const code = status >= 400 ? status : response.status;
      return new Error((message || this.dataset.error) + (code >= 400 ? ` (HTTP ${code})` : ''));
    }
    async add(event) {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || this.button.disabled) return;
      const selected = this.offers.find(input => input.checked && !input.disabled);
      const variantId = this.variant.value;
      const planId = this.plan?.value || '';
      if (!selected || !/^\d+$/.test(variantId) || !Number.isSafeInteger(Number(selected.value)) || Number(selected.value) < 1 || (planId && !this.plans[variantId]?.[planId])) {
        this.error.textContent = this.dataset.error; this.error.hidden = false; return;
      }
      this.busy = true; this.button.disabled = true; this.button.setAttribute('aria-busy','true'); this.error.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      const data = new FormData();
      data.set('id', variantId);
      data.set('quantity', selected.value);
      if (planId) data.set('selling_plan', planId);
      const eventClass = window.StandardEvents?.CartLinesUpdateEvent;
      let deferred;
      if (eventClass) {
        try {
          deferred = eventClass.createPromise();
          this.dispatchEvent(new eventClass({action:'add',context:'product',lines:[{merchandiseId:variantId,quantity:Number(selected.value)}],promise:deferred.promise}));
        } catch { deferred = null; }
      }
      const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
      if (sections.length) {data.append('sections',sections.join(','));data.append('sections_url',location.pathname); drawer.setActiveElement?.(this.button);}
      let added = false;
      try {
        const response = await fetch(this.ajaxUrl(this.dataset.addUrl),{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        let result = await response.json().catch(() => null);
        const error = this.cartError(response, result);
        if (error) throw error;
        if (!result || !(result.id || result.items?.length)) {location.assign(this.dataset.cartUrl);return;}
        added = true;
        if (deferred) {
          fetch(this.ajaxUrl(this.dataset.cartUrl),{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cart=>deferred.resolve({cart:eventClass.createCartFromAjaxResponse(cart)})).catch(error=>deferred.reject(error));
        }
        if (selected?.dataset.code && !planId) {
          const discountResponse = await fetch(this.ajaxUrl(this.dataset.updateUrl),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:selected.dataset.code,sections,sections_url:location.pathname})});
          const updated = await discountResponse.json();
          if (this.cartError(discountResponse, updated)) {location.assign(this.dataset.cartUrl);return;}
          result = updated;
        }
        if (drawer && sections.every(id => result.sections?.[id])) {
          drawer.classList.remove('is-empty'); drawer.renderContents(result);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            fetch(this.ajaxUrl(this.dataset.cartUrl),{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cartData=>publish(PUB_SUB_EVENTS.cartUpdate,{source:'lisado-story',productVariantId:variantId,cartData})).catch(()=>{});
          }
        } else location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (added) {location.assign(this.dataset.cartUrl);return;}
        deferred?.reject(error);
        const CartError = window.StandardEvents?.CartErrorEvent;
        if (CartError) this.dispatchEvent(new CartError({error:error.message || this.dataset.error,code:'INVALID'}));
        this.error.textContent = error.message || this.dataset.error; this.error.hidden = false;
      } finally {
        this.busy = false; this.button.removeAttribute('aria-busy'); this.update(false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisado-shilajit-harz-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lisado-shilajit-harz-product')) {
  customElements.define('lisado-shilajit-harz-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form.se-story__form');
      if (!this.form) return;
      this.variant = this.form.querySelector('[data-story-variant]');
      this.offers = [...this.form.querySelectorAll('[data-story-quantity]')];
      this.plan = this.form.querySelector('[data-story-plan]');
      this.plans = JSON.parse(this.querySelector('[data-story-plans]')?.textContent || '{}');
      this.button = this.form.querySelector('.se-story__add');
      this.error = this.querySelector('.se-story__error');
      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-story-variant],[data-story-quantity],[data-story-plan]')) this.update(true);
      }, options);
      this.form.addEventListener('submit', event => this.add(event), options);
      this.slides = this.querySelector('.se-story__slides');
      if (this.slides) {
        const slides = [...this.slides.children];
        const thumbs = [...this.querySelectorAll('[data-slide]')];
        const position = index => Math.max(0, Math.min(this.slides.scrollWidth - this.slides.clientWidth, slides[index].offsetLeft - slides[0].offsetLeft));
        this.goToSlide = index => {
          const target = Math.max(0, Math.min(index, slides.length - 1));
          this.slides.scrollTo({left:position(target), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.updateGallery = () => {
          const previousSlide = this.activeSlide;
          this.activeSlide = slides.reduce((best, slide, index) => Math.abs(position(index) - this.slides.scrollLeft) < Math.abs(position(best) - this.slides.scrollLeft) ? index : best, 0);
          if (Number.isInteger(previousSlide) && previousSlide !== this.activeSlide) window.pauseAllMedia?.();
          thumbs.forEach(button => {const active = Number(button.dataset.slide) === this.activeSlide;button.classList.toggle('is-aktiv', active);button.setAttribute('aria-current', String(active));});
          this.querySelector('.mmb__fahne')?.classList.toggle('ist-weg', this.activeSlide !== 0);
        };
        thumbs.forEach(button => button.addEventListener('click', () => this.goToSlide(Number(button.dataset.slide)), options));
        this.slides.addEventListener('scroll', () => {cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.updateGallery);}, {...options, passive:true});
        this.slides.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          this.goToSlide(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : (this.activeSlide || 0) + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        window.addEventListener('resize', this.updateGallery, options);
        if (window.ResizeObserver) {this.resizeObserver = new ResizeObserver(this.updateGallery);this.resizeObserver.observe(this.slides);}
        this.updateGallery();
      }
      document.addEventListener('lisado-story:selection', event => {
        if (event.detail.source === this || event.detail.product !== this.dataset.product) return;
        this.variant.value = event.detail.variant;
        if (this.plan) this.plan.value = event.detail.plan || '';
        const offer = this.offers.find(input => Number(input.value) === event.detail.quantity);
        if (offer) offer.checked = true;
        this.update(false);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.se-story__slide');
        if (slide && this.contains(slide)) this.goToSlide?.([...this.slides.children].indexOf(slide));
      }, options);
      if (this.dataset.mode === 'final') {
        const main = document.querySelector('lisado-shilajit-harz-product[data-mode="main"]');
        const mainVariant = main?.querySelector('[data-story-variant]');
        const mainQuantity = main?.querySelector('[data-story-quantity]:checked');
        if (this.plan && main?.plan) this.plan.value = main.plan.value;
        if (mainVariant && [...this.variant.options].some(option => option.value === mainVariant.value)) this.variant.value = mainVariant.value;
        const offer = this.offers.find(input => input.value === mainQuantity?.value);
        if (offer) offer.checked = true;
      }
      this.update(false);
      const selected = this.offers.find(input => input.checked && !input.disabled);
      if (selected) document.dispatchEvent(new CustomEvent('lisado-story:selection', {detail:{source:this,product:this.dataset.product,variant:this.variant.value,plan:this.plan?.value || '',quantity:Number(selected.value),price:this.money(this.price(selected,this.variant.selectedOptions[0].dataset).total)}}));
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); cancelAnimationFrame(this.frame); }
    money(cents) { return new Intl.NumberFormat(this.dataset.locale || 'de', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(cents / 100); }
    unitPrice(total, quantity, variant) {
      const factor = {kg:1, g:0.001, mg:0.000001}[variant.measureUnit];
      const netKg = Number(variant.measureValue) * factor;
      if (netKg > 0 && quantity > 0) return {unit:Math.round(total / (netKg * quantity)), reference:'kg'};
      const baseTotal = Number(variant.price) * quantity;
      const reference = (variant.reference || '').replace(/^1(?=[a-z])/i, '');
      return {unit:baseTotal > 0 ? Math.round(Number(variant.unit) * total / baseTotal) : 0, reference};
    }
    price(input, variant) {
      const allocation = this.plans[this.variant.value]?.[this.plan?.value];
      const price = Number(allocation ? allocation.price : variant.price);
      const discount = allocation ? 0 : Math.floor(price * Math.min(100, Math.max(0, Number(input.dataset.discount))) / 100);
      const quantity = Number(input.value);
      const fixedTotal = allocation ? 0 : Number(input.dataset.fixedTotal || 0);
      const total = fixedTotal > 0 ? fixedTotal : (price - discount) * quantity;
      const each = fixedTotal > 0 ? Math.round(fixedTotal / quantity) : price - discount;
      return {each, total, compare:Math.max(price,Number(allocation ? allocation.compare : variant.compare)) * quantity, ...this.unitPrice(total, quantity, variant)};
    }
    update(broadcast) {
      const option = this.variant.selectedOptions[0];
      if (!option) return;
      const variant = option.dataset;
      const allocations = this.plans[this.variant.value] || {};
      if (this.plan) {
        for (const plan of this.plan.options) {
          plan.disabled = plan.value ? !allocations[plan.value] : variant.planRequired === 'true';
          plan.hidden = plan.disabled;
        }
        if (!this.plan.selectedOptions[0] || this.plan.selectedOptions[0].disabled) this.plan.value = [...this.plan.options].find(p => !p.disabled)?.value || '';
      }
      const allocation = allocations[this.plan?.value];
      this.querySelectorAll('[data-plan-note],[data-plan-total]').forEach(el => el.hidden = !allocation);
      const onceNote = this.querySelector('[data-once-note]');
      if (onceNote) onceNote.hidden = !!allocation;
      const description = this.querySelector('[data-plan-description]');
      if (description) {description.textContent = allocation?.description || '';description.hidden = !description.textContent;}
      this.offers.forEach(input => {
        const quantity = Number(input.value);
        input.disabled = variant.available !== 'true' || (variant.planRequired === 'true' && !allocation) || quantity < Number(variant.min) || (Number(variant.max) > 0 && quantity > Number(variant.max)) || (quantity - Number(variant.min)) % Number(variant.step) !== 0;
        const row = input.closest('.se-story__offer');
        row.classList.toggle('is-disabled', input.disabled);
        row.classList.toggle('sr-bundle__bar--selected',input.checked);
        const prices = this.price(input, variant);
        row.querySelector('[data-total]').textContent = this.money(prices.total);
        row.querySelector('[data-each]').textContent = this.money(prices.each);
        const compare = row.querySelector('[data-compare]');
        compare.textContent = this.money(prices.compare);
        compare.hidden = prices.compare <= prices.total;
      });
      let selected = this.offers.find(input => input.checked && !input.disabled);
      if (!selected) { selected = this.offers.find(input => !input.disabled); if (selected) selected.checked = true; }
      this.offers.forEach(input=>input.closest('.se-story__offer').classList.toggle('sr-bundle__bar--selected',input.checked));
      this.button.disabled = !selected || this.busy;
      this.button.querySelector('[data-button-label]').textContent = selected ? this.dataset.addLabel : this.dataset.soldLabel;
      const delivery = this.querySelector('[data-plan-delivery]');
      if (delivery) delivery.textContent = allocation && selected ? this.money(allocation.delivery * Number(selected.value)) : '';
      const price = selected ? this.price(selected,variant) : {total:Number(variant.price),...this.unitPrice(Number(variant.price),1,variant)};
      this.querySelectorAll('[data-selected-total], [data-story-button-price]').forEach(el => el.textContent = this.money(price.total));
      const unit = this.querySelector('[data-selected-unit]');
      unit.textContent = price.reference ? this.money(price.unit) + '/' + price.reference : '';
      const availability = this.querySelector('[data-availability]');
      if (availability) availability.textContent = variant.available === 'true' ? this.dataset.stockLabel : this.dataset.soldLabel;
      this.form.querySelector('[data-story-variant-input]').value = this.variant.value;
      this.form.querySelector('[data-story-quantity-input]').value = selected?.value || '0';
      const planInput = this.form.querySelector('[data-story-plan-input]');
      planInput.value = this.plan?.value || '';
      planInput.disabled = !planInput.value;
      if (broadcast && selected) {
        const detail = {source:this,product:this.dataset.product,variant:this.variant.value,plan:this.plan?.value || '',quantity:Number(selected.value),price:this.money(price.total)};
        document.dispatchEvent(new CustomEvent('lisado-story:selection',{detail}));
        const url = new URL(location.href); url.searchParams.set('variant',this.variant.value); history.replaceState({},'',url);
      }
    }
    ajaxUrl(route) {
      const url = new URL(route, location.origin);
      url.pathname = url.pathname.replace(/\/$/, '').replace(/(?:\.js)?$/, '.js');
      return url.pathname + url.search;
    }
    cartError(response, result) {
      const status = Number(result?.status);
      if (response.ok !== false && !(response.status >= 400) && !(status >= 400)) return null;
      const message = [result?.description, result?.message, result?.errors].find(value => typeof value === 'string' && value.trim());
      const code = status >= 400 ? status : response.status;
      return new Error((message || this.dataset.error) + (code >= 400 ? ` (HTTP ${code})` : ''));
    }
    async add(event) {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || this.button.disabled) return;
      const selected = this.offers.find(input => input.checked && !input.disabled);
      const variantId = this.variant.value;
      const planId = this.plan?.value || '';
      if (!selected || !/^\d+$/.test(variantId) || !Number.isSafeInteger(Number(selected.value)) || Number(selected.value) < 1 || (planId && !this.plans[variantId]?.[planId])) {
        this.error.textContent = this.dataset.error; this.error.hidden = false; return;
      }
      this.busy = true; this.button.disabled = true; this.button.setAttribute('aria-busy','true'); this.error.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      const data = new FormData();
      data.set('id', variantId);
      data.set('quantity', selected.value);
      if (planId) data.set('selling_plan', planId);
      const eventClass = window.StandardEvents?.CartLinesUpdateEvent;
      let deferred;
      if (eventClass) {
        try {
          deferred = eventClass.createPromise();
          this.dispatchEvent(new eventClass({action:'add',context:'product',lines:[{merchandiseId:variantId,quantity:Number(selected.value)}],promise:deferred.promise}));
        } catch { deferred = null; }
      }
      const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
      if (sections.length) {data.append('sections',sections.join(','));data.append('sections_url',location.pathname); drawer.setActiveElement?.(this.button);}
      let added = false;
      try {
        const response = await fetch(this.ajaxUrl(this.dataset.addUrl),{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        let result = await response.json().catch(() => null);
        const error = this.cartError(response, result);
        if (error) throw error;
        if (!result || !(result.id || result.items?.length)) {location.assign(this.dataset.cartUrl);return;}
        added = true;
        if (deferred) {
          fetch(this.ajaxUrl(this.dataset.cartUrl),{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cart=>deferred.resolve({cart:eventClass.createCartFromAjaxResponse(cart)})).catch(error=>deferred.reject(error));
        }
        if (selected?.dataset.code && !planId) {
          const discountResponse = await fetch(this.ajaxUrl(this.dataset.updateUrl),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:selected.dataset.code,sections,sections_url:location.pathname})});
          const updated = await discountResponse.json();
          if (this.cartError(discountResponse, updated)) {location.assign(this.dataset.cartUrl);return;}
          result = updated;
        }
        if (drawer && sections.every(id => result.sections?.[id])) {
          drawer.classList.remove('is-empty'); drawer.renderContents(result);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            fetch(this.ajaxUrl(this.dataset.cartUrl),{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cartData=>publish(PUB_SUB_EVENTS.cartUpdate,{source:'lisado-story',productVariantId:variantId,cartData})).catch(()=>{});
          }
        } else location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (added) {location.assign(this.dataset.cartUrl);return;}
        deferred?.reject(error);
        const CartError = window.StandardEvents?.CartErrorEvent;
        if (CartError) this.dispatchEvent(new CartError({error:error.message || this.dataset.error,code:'INVALID'}));
        this.error.textContent = error.message || this.dataset.error; this.error.hidden = false;
      } finally {
        this.busy = false; this.button.removeAttribute('aria-busy'); this.update(false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisado-shilajit-harz-sticky"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lisado-story-sticky')) customElements.define('lisado-story-sticky',class extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.querySelector('[data-hoch]').addEventListener('click',()=>{const form=document.querySelector('.se-story-product--main .se-story__form');form?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});},{signal:this.controller.signal});
    const update = () => {
      const main = document.querySelector('.se-story-product--main');
      if (!main) {this.hidden=true;return;}
      const mainVisible = main.getBoundingClientRect().bottom > 120;
      const final = document.querySelector('.se-story-product--final');
      const rect = final?.getBoundingClientRect();
      this.hidden = mainVisible || Boolean(rect && rect.top < innerHeight && rect.bottom > 0);
    };
    document.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(update);},{passive:true,signal:this.controller.signal});
    window.addEventListener('resize',update,{signal:this.controller.signal});
    document.addEventListener('shopify:section:load',update,{signal:this.controller.signal});
    document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(update),{signal:this.controller.signal}); update();
  }
  disconnectedCallback(){this.controller?.abort();cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisado-story-header"] && !Shopify.designMode) return;
  try {
    
if (!window.lisadoStoryCartLink) {
  window.lisadoStoryCartLink = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-story-cart]');
    const drawer = document.querySelector('cart-drawer');
    if (event.defaultPrevented || !link || !drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(link);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisado-story-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lisado-story-product')) {
  customElements.define('lisado-story-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form.se-story__form');
      if (!this.form) return;
      this.variant = this.form.querySelector('[data-story-variant]');
      this.offers = [...this.form.querySelectorAll('[data-story-quantity]')];
      this.plan = this.form.querySelector('[data-story-plan]');
      this.plans = JSON.parse(this.querySelector('[data-story-plans]')?.textContent || '{}');
      this.button = this.form.querySelector('.se-story__add');
      this.error = this.querySelector('.se-story__error');
      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-story-variant],[data-story-quantity],[data-story-plan]')) this.update(true);
      }, options);
      this.form.addEventListener('submit', event => this.add(event), options);
      this.slides = this.querySelector('.se-story__slides');
      if (this.slides) {
        const slides = [...this.slides.children];
        const thumbs = [...this.querySelectorAll('[data-slide]')];
        const position = index => Math.max(0, Math.min(this.slides.scrollWidth - this.slides.clientWidth, slides[index].offsetLeft - slides[0].offsetLeft));
        this.goToSlide = index => {
          const target = Math.max(0, Math.min(index, slides.length - 1));
          this.slides.scrollTo({left:position(target), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.updateGallery = () => {
          const previousSlide = this.activeSlide;
          this.activeSlide = slides.reduce((best, slide, index) => Math.abs(position(index) - this.slides.scrollLeft) < Math.abs(position(best) - this.slides.scrollLeft) ? index : best, 0);
          if (Number.isInteger(previousSlide) && previousSlide !== this.activeSlide) window.pauseAllMedia?.();
          thumbs.forEach(button => {const active = Number(button.dataset.slide) === this.activeSlide;button.classList.toggle('is-aktiv', active);button.setAttribute('aria-current', String(active));});
          this.querySelector('.mmb__fahne')?.classList.toggle('ist-weg', this.activeSlide !== 0);
        };
        thumbs.forEach(button => button.addEventListener('click', () => this.goToSlide(Number(button.dataset.slide)), options));
        this.slides.addEventListener('scroll', () => {cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.updateGallery);}, {...options, passive:true});
        this.slides.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          this.goToSlide(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : (this.activeSlide || 0) + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        window.addEventListener('resize', this.updateGallery, options);
        if (window.ResizeObserver) {this.resizeObserver = new ResizeObserver(this.updateGallery);this.resizeObserver.observe(this.slides);}
        this.updateGallery();
      }
      document.addEventListener('lisado-story:selection', event => {
        if (event.detail.source === this || event.detail.product !== this.dataset.product) return;
        this.variant.value = event.detail.variant;
        if (this.plan) this.plan.value = event.detail.plan || '';
        const offer = this.offers.find(input => Number(input.value) === event.detail.quantity);
        if (offer) offer.checked = true;
        this.update(false);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.se-story__slide');
        if (slide && this.contains(slide)) this.goToSlide?.([...this.slides.children].indexOf(slide));
      }, options);
      if (this.dataset.mode === 'final') {
        const main = document.querySelector('lisado-story-product[data-mode="main"]');
        const mainVariant = main?.querySelector('[data-story-variant]');
        const mainQuantity = main?.querySelector('[data-story-quantity]:checked');
        if (this.plan && main?.plan) this.plan.value = main.plan.value;
        if (mainVariant && [...this.variant.options].some(option => option.value === mainVariant.value)) this.variant.value = mainVariant.value;
        const offer = this.offers.find(input => input.value === mainQuantity?.value);
        if (offer) offer.checked = true;
      }
      this.update(false);
      const selected = this.offers.find(input => input.checked && !input.disabled);
      if (selected) document.dispatchEvent(new CustomEvent('lisado-story:selection', {detail:{source:this,product:this.dataset.product,variant:this.variant.value,plan:this.plan?.value || '',quantity:Number(selected.value),price:this.money(this.price(selected,this.variant.selectedOptions[0].dataset).total)}}));
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); cancelAnimationFrame(this.frame); }
    money(cents) { return new Intl.NumberFormat(this.dataset.locale || 'de', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(cents / 100); }
    unitPrice(total, quantity, variant) {
      const factor = {kg:1, g:0.001, mg:0.000001}[variant.measureUnit];
      const netKg = Number(variant.measureValue) * factor;
      if (netKg > 0 && quantity > 0) return {unit:Math.round(total / (netKg * quantity)), reference:'kg'};
      const baseTotal = Number(variant.price) * quantity;
      const reference = (variant.reference || '').replace(/^1(?=[a-z])/i, '');
      return {unit:baseTotal > 0 ? Math.round(Number(variant.unit) * total / baseTotal) : 0, reference};
    }
    price(input, variant) {
      const allocation = this.plans[this.variant.value]?.[this.plan?.value];
      const price = Number(allocation ? allocation.price : variant.price);
      const discount = allocation ? 0 : Math.floor(price * Math.min(100, Math.max(0, Number(input.dataset.discount))) / 100);
      const quantity = Number(input.value);
      const total = (price - discount) * quantity;
      return {each:price - discount, total, compare:Math.max(price,Number(allocation ? allocation.compare : variant.compare)) * quantity, ...this.unitPrice(total, quantity, variant)};
    }
    update(broadcast) {
      const option = this.variant.selectedOptions[0];
      if (!option) return;
      const variant = option.dataset;
      const allocations = this.plans[this.variant.value] || {};
      if (this.plan) {
        for (const plan of this.plan.options) {
          plan.disabled = plan.value ? !allocations[plan.value] : variant.planRequired === 'true';
          plan.hidden = plan.disabled;
        }
        if (!this.plan.selectedOptions[0] || this.plan.selectedOptions[0].disabled) this.plan.value = [...this.plan.options].find(p => !p.disabled)?.value || '';
      }
      const allocation = allocations[this.plan?.value];
      this.querySelectorAll('[data-plan-note],[data-plan-total]').forEach(el => el.hidden = !allocation);
      const onceNote = this.querySelector('[data-once-note]');
      if (onceNote) onceNote.hidden = !!allocation;
      const description = this.querySelector('[data-plan-description]');
      if (description) {description.textContent = allocation?.description || '';description.hidden = !description.textContent;}
      this.offers.forEach(input => {
        const quantity = Number(input.value);
        input.disabled = variant.available !== 'true' || (variant.planRequired === 'true' && !allocation) || quantity < Number(variant.min) || (Number(variant.max) > 0 && quantity > Number(variant.max)) || (quantity - Number(variant.min)) % Number(variant.step) !== 0;
        const row = input.closest('.se-story__offer');
        row.classList.toggle('is-disabled', input.disabled);
        row.classList.toggle('sr-bundle__bar--selected',input.checked);
        const prices = this.price(input, variant);
        row.querySelector('[data-total]').textContent = this.money(prices.total);
        row.querySelector('[data-each]').textContent = this.money(prices.each);
        const compare = row.querySelector('[data-compare]');
        compare.textContent = this.money(prices.compare);
        compare.hidden = prices.compare <= prices.total;
      });
      let selected = this.offers.find(input => input.checked && !input.disabled);
      if (!selected) { selected = this.offers.find(input => !input.disabled); if (selected) selected.checked = true; }
      this.offers.forEach(input=>input.closest('.se-story__offer').classList.toggle('sr-bundle__bar--selected',input.checked));
      this.button.disabled = !selected || this.busy;
      this.button.querySelector('[data-button-label]').textContent = selected ? this.dataset.addLabel : this.dataset.soldLabel;
      const delivery = this.querySelector('[data-plan-delivery]');
      if (delivery) delivery.textContent = allocation && selected ? this.money(allocation.delivery * Number(selected.value)) : '';
      const price = selected ? this.price(selected,variant) : {total:Number(variant.price),...this.unitPrice(Number(variant.price),1,variant)};
      this.querySelectorAll('[data-selected-total], [data-story-button-price]').forEach(el => el.textContent = this.money(price.total));
      const unit = this.querySelector('[data-selected-unit]');
      unit.textContent = price.reference ? this.money(price.unit) + '/' + price.reference : '';
      const availability = this.querySelector('[data-availability]');
      if (availability) availability.textContent = variant.available === 'true' ? this.dataset.stockLabel : this.dataset.soldLabel;
      this.form.querySelector('[data-story-variant-input]').value = this.variant.value;
      this.form.querySelector('[data-story-quantity-input]').value = selected?.value || '0';
      const planInput = this.form.querySelector('[data-story-plan-input]');
      planInput.value = this.plan?.value || '';
      planInput.disabled = !planInput.value;
      if (broadcast && selected) {
        const detail = {source:this,product:this.dataset.product,variant:this.variant.value,plan:this.plan?.value || '',quantity:Number(selected.value),price:this.money(price.total)};
        document.dispatchEvent(new CustomEvent('lisado-story:selection',{detail}));
        const url = new URL(location.href); url.searchParams.set('variant',this.variant.value); history.replaceState({},'',url);
      }
    }
    ajaxUrl(route) {
      const url = new URL(route, location.origin);
      url.pathname = url.pathname.replace(/\/$/, '').replace(/(?:\.js)?$/, '.js');
      return url.pathname + url.search;
    }
    cartError(response, result) {
      const status = Number(result?.status);
      if (response.ok !== false && !(response.status >= 400) && !(status >= 400)) return null;
      const message = [result?.description, result?.message, result?.errors].find(value => typeof value === 'string' && value.trim());
      const code = status >= 400 ? status : response.status;
      return new Error((message || this.dataset.error) + (code >= 400 ? ` (HTTP ${code})` : ''));
    }
    async add(event) {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || this.button.disabled) return;
      const selected = this.offers.find(input => input.checked && !input.disabled);
      const variantId = this.variant.value;
      const planId = this.plan?.value || '';
      if (!selected || !/^\d+$/.test(variantId) || !Number.isSafeInteger(Number(selected.value)) || Number(selected.value) < 1 || (planId && !this.plans[variantId]?.[planId])) {
        this.error.textContent = this.dataset.error; this.error.hidden = false; return;
      }
      this.busy = true; this.button.disabled = true; this.button.setAttribute('aria-busy','true'); this.error.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      const data = new FormData();
      data.set('id', variantId);
      data.set('quantity', selected.value);
      if (planId) data.set('selling_plan', planId);
      const eventClass = window.StandardEvents?.CartLinesUpdateEvent;
      let deferred;
      if (eventClass) {
        try {
          deferred = eventClass.createPromise();
          this.dispatchEvent(new eventClass({action:'add',context:'product',lines:[{merchandiseId:variantId,quantity:Number(selected.value)}],promise:deferred.promise}));
        } catch { deferred = null; }
      }
      const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
      if (sections.length) {data.append('sections',sections.join(','));data.append('sections_url',location.pathname); drawer.setActiveElement?.(this.button);}
      let added = false;
      try {
        const response = await fetch(this.ajaxUrl(this.dataset.addUrl),{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        let result = await response.json().catch(() => null);
        const error = this.cartError(response, result);
        if (error) throw error;
        if (!result || !(result.id || result.items?.length)) {location.assign(this.dataset.cartUrl);return;}
        added = true;
        if (deferred) {
          fetch(this.ajaxUrl(this.dataset.cartUrl),{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cart=>deferred.resolve({cart:eventClass.createCartFromAjaxResponse(cart)})).catch(error=>deferred.reject(error));
        }
        if (selected?.dataset.code && !planId) {
          const discountResponse = await fetch(this.ajaxUrl(this.dataset.updateUrl),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:selected.dataset.code,sections,sections_url:location.pathname})});
          const updated = await discountResponse.json();
          if (this.cartError(discountResponse, updated)) {location.assign(this.dataset.cartUrl);return;}
          result = updated;
        }
        if (drawer && sections.every(id => result.sections?.[id])) {
          drawer.classList.remove('is-empty'); drawer.renderContents(result);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            fetch(this.ajaxUrl(this.dataset.cartUrl),{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cartData=>publish(PUB_SUB_EVENTS.cartUpdate,{source:'lisado-story',productVariantId:variantId,cartData})).catch(()=>{});
          }
        } else location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (added) {location.assign(this.dataset.cartUrl);return;}
        deferred?.reject(error);
        const CartError = window.StandardEvents?.CartErrorEvent;
        if (CartError) this.dispatchEvent(new CartError({error:error.message || this.dataset.error,code:'INVALID'}));
        this.error.textContent = error.message || this.dataset.error; this.error.hidden = false;
      } finally {
        this.busy = false; this.button.removeAttribute('aria-busy'); this.update(false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisado-story-promo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lisado-story-promo')) customElements.define('lisado-story-promo', class extends HTMLElement {
  connectedCallback() {
    clearInterval(this.timer);

    const counter = this.querySelector('[data-uhr]');
    const text = this.querySelector('.mmt__text');
    const rawDeadline = this.dataset.deadline.trim();
    const finalDeadline = rawDeadline ? Date.parse(rawDeadline) : null;

    if (rawDeadline && !Number.isFinite(finalDeadline)) {
      if (window.Shopify?.designMode) {
        counter.hidden = false;
        counter.querySelectorAll('.mmt__zahl').forEach(el => el.textContent = '--');
      }
      return;
    }

    // Mitternacht in Deutschland: fuer alle Besucher derselbe Zeitpunkt.
    const berlin = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    });
    const parts = time => Object.fromEntries(
      berlin.formatToParts(time)
        .filter(part => part.type !== 'literal')
        .map(part => [part.type, Number(part.value)])
    );

    const nextMidnight = now => {
      const today = parts(now);
      const utc = Date.UTC(today.year, today.month - 1, today.day + 1);
      const atUtc = parts(utc);
      const offset = Date.UTC(
        atUtc.year, atUtc.month - 1, atUtc.day,
        atUtc.hour, atUtc.minute, atUtc.second
      ) - utc;
      return utc - offset;
    };

    const tick = () => {
      const now = Date.now();

      if (finalDeadline !== null && now >= finalDeadline) {
        counter.hidden = true;
        text.textContent = this.dataset.expired;
        clearInterval(this.timer);
        return;
      }

      const end = Math.min(nextMidnight(now), finalDeadline ?? Infinity);
      const left = Math.max(0, Math.ceil((end - now) / 1000));
      const values = [Math.floor(left / 3600), Math.floor(left / 60) % 60, left % 60];

      counter.hidden = false;
      ['std', 'min', 'sek'].forEach((key, i) => {
        counter.querySelector('[data-' + key + ']').textContent = String(values[i]).padStart(2, '0');
      });
    };

    tick();
    if (finalDeadline === null || Date.now() < finalDeadline) {
      this.timer = setInterval(tick, 1000);
    }
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisado-story-sticky"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lisado-story-sticky')) customElements.define('lisado-story-sticky',class extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.querySelector('[data-hoch]').addEventListener('click',()=>{const form=document.querySelector('.se-story-product--main .se-story__form');form?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});},{signal:this.controller.signal});
    const update = () => {
      const main = document.querySelector('.se-story-product--main');
      if (!main) {this.hidden=true;return;}
      const mainVisible = main.getBoundingClientRect().bottom > 120;
      const final = document.querySelector('.se-story-product--final');
      const rect = final?.getBoundingClientRect();
      this.hidden = mainVisible || Boolean(rect && rect.top < innerHeight && rect.bottom > 0);
    };
    document.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(update);},{passive:true,signal:this.controller.signal});
    window.addEventListener('resize',update,{signal:this.controller.signal});
    document.addEventListener('shopify:section:load',update,{signal:this.controller.signal});
    document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(update),{signal:this.controller.signal}); update();
  }
  disconnectedCallback(){this.controller?.abort();cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();
})();
